import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'Unikai',       //theme name
        false,           //loadingSpinner
        false,           //fixedHeader
        true,           //sidenavIsOpened
        true,           //sidenavIsPinned  
        false,           //sidenavUserBlock 
        'vertical',     //horizontal , vertical
        'default',      //default, compact, mini
        'teal-light', //indigo-light, teal-light, red-light, blue-dark, green-dark, pink-dark
        false,          // true = rtl, false = ltr
        false,            // true = has footer, false = no footer
        'https://rest.unikai.com/',
        // 'https://unikai.crafttechhub.com/',
    )
}

